import type { QuickSearchCategoryView, QuickSearchView } from './quickSearchRoutes'
import type { QuickSearchCategoryName, QuickSearchResponse } from '@/types/searchTypes'
import { VpFormControl, VpRadioGroupChip, VpRadioGroupChipItem, VpRadioGroupChipItemLabel } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useQuickSearchLabels } from './quickSearchLabels'

interface QuickSearchChipsProps {
  selectedView: QuickSearchView
  onSelectView: (view: QuickSearchView) => void
  response?: QuickSearchResponse
  categoryTotals?: Partial<Record<QuickSearchCategoryName, number>>
}

export function QuickSearchChips({
  selectedView,
  onSelectView,
  response,
  categoryTotals,
}: Readonly<QuickSearchChipsProps>) {
  const { t } = useTranslation()
  const { CHIP_LABELS } = useQuickSearchLabels()
  const categories = response?.categories

  return (
    <div className="quick-search__chips" data-testid="quick-search-chips">
      <VpFormControl>
        <VpRadioGroupChip
          id="quick-search-chips-group"
          name="quick-search-chips-group"
          value={selectedView}
          onChange={(event) => {
            onSelectView(event.target.value as QuickSearchView)
          }}
        >
          <VpRadioGroupChipItem
            value="all"
            aria-label={t('quick-search.all')}
            size="small"
            labelSlot={
              <VpRadioGroupChipItemLabel>{t('quick-search.all')}</VpRadioGroupChipItemLabel>
            }
          />
          {(Object.keys(CHIP_LABELS) as Array<QuickSearchCategoryView>).map((view) => {
            const total = categoryTotals?.[view] ?? categories?.[view].total
            const isKnownEmpty = total === 0

            return (
              <VpRadioGroupChipItem
                key={view}
                value={view}
                disabled={isKnownEmpty}
                aria-disabled={isKnownEmpty}
                aria-label={CHIP_LABELS[view]}
                size="small"
                labelSlot={(
                  <VpRadioGroupChipItemLabel>
                    {CHIP_LABELS[view]}
                  </VpRadioGroupChipItemLabel>
                )}
              />
            )
          })}
        </VpRadioGroupChip>
      </VpFormControl>
    </div>
  )
}
